export const TOGGLE_STATE_ON = 'on';
export const TOGGLE_STATE_OFF = 'off';
export const MUST_HAVE_TOGGLE_TYPE = 'must have role requirement questions';
